import api from '@/api'
import store from '@/store'
import APIUrls from '@/config/simpliciti-apis'
import { getEnvIntValue } from './env-service'
import moment from 'moment'

/**
 * Fetch release notes with multiple filters
 * @return {Promise<void>}
 */
export async function fetchReleaseNotes() {
  let payload = getReleaseNotesHistoryPayload()

  let releaseNotesHistory = await api.v3.get(
    APIUrls.API_V3_RELEASE_NOTES,
    payload
  )

  releaseNotesHistory = releaseNotesHistory.data.sort((a, b) => {
    return moment(b.publishedAt, 'YYYY-MM-DD HH:mm:ss').diff(
      moment(a.publishedAt, 'YYYY-MM-DD HH:mm:ss')
    )
  })

  let debugConsole = store.getters['release_notes/debugConsole']

  // store.commit('release_notes/setReleaseNoteItem', lastActiveReleaseNote)
  store.commit('release_notes/setReleaseNotesHistory', releaseNotesHistory)
  debugConsole && console.log('rnf: syncRemoteHistory', { releaseNotesHistory })
}

/**
 * Returns payload to release notes requests
 * @return {any}
 */
function getReleaseNotesHistoryPayload() {
  return {
    applicationId: getEnvIntValue('VITE_GEONLINE_APPLICATION_ID'),
    isArchived: false,
    isDraft: false,
    isTemplate: false,
    language: store.getters['release_notes/currentLocaleCode'],
    'order[updatedAt]': 'desc',
    itemsPerPage: 999999,
    'publishedAt[after]': moment().subtract(1, 'year').format('YYYY-MM-DD'),
  }
}
